import React from 'react';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import Typography from '@mui/material/Typography';

import type { ChangeEvent } from 'react';

export const CheckboxWithLabel = ({
    label,
    bottomText,
    value,
    onChange,
    onBlur,
    name,
    disabled = false,
    error,
}: {
    label: string | React.ReactElement;
    bottomText?: string | React.ReactElement;
    value: boolean;
    name: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (e: ChangeEvent) => void;
    fullWidth?: boolean;
    disabled?: boolean;
    error?: string;
}) => {
    return (
        <Box mt={3}>
            <FormControlLabel
                control={(
                    <Checkbox
                        checked={value}
                        color="primary"
                        disabled={disabled}
                        name={name}
                        onBlur={onBlur}
                        onChange={onChange}
                    />
                )}
                label={label}
            />
            {bottomText && <> <br /> <Typography color="textSecondary" variant="caption">{bottomText}</Typography></> }
            {error && <FormHelperText>{error}</FormHelperText>}
        </Box>
    );
};
